export enum EPaymentUrls {
  PAYMENT = 'payment',
}
